import { FoodLine, FoodTray, FoodTraySize, FoodTrayTemplate } from '../../models';
import { ValueOf } from '../../utils/values-of';
import { ActionType } from './types';

export const resetFoodTrayTemplate = (departmentId: string) => ({
  type: ActionType.RESET_FOOD_TRAY_TEMPLATE,
  payload: {
    departmentId,
  },
});

export const setFoodTrayTemplate = (foodTrayTemplate: FoodTrayTemplate, replaceInitial: boolean) => ({
  type: ActionType.SET_FOOD_TRAY_TEMPLATE,
  payload: {
    foodTrayTemplate,
    replaceInitial,
  },
});

export const setFoodTrayTemplateProp = (propName: keyof FoodTrayTemplate, propValue: ValueOf<FoodTrayTemplate>) => ({
  type: ActionType.SET_FOOD_TRAY_TEMPLATE_PROP,
  payload: {
    propName,
    propValue,
  },
});

export const addFoodLine = () => ({
  type: ActionType.ADD_FOOD_LINE,
});

export const setFoodLineProp = (
  propName: keyof FoodLine,
  propValue: ValueOf<FoodLine>,
  foodLineIndex: number, // We use the index and not the id or the objects since the object could be new and not have an id yet
) => ({
  type: ActionType.SET_FOOD_LINE_PROP,
  payload: {
    propName,
    propValue,
    foodLineIndex,
  },
});

export const removeFoodLine = (foodLineIndex: number) => ({
  type: ActionType.REMOVE_FOOD_LINE,
  payload: {
    foodLineIndex,
  },
});

export const setFoodTraysForColumn = (foodTraySizes: FoodTraySize[], foodLineIndex: number, columnIndex: number) => ({
  type: ActionType.SET_FOOD_TRAYS_FOR_COLUMN,
  payload: {
    foodTraySizes,
    foodLineIndex,
    columnIndex,
  },
});

export const addFoodTrayColumn = (foodTrays: Partial<FoodTray>[], foodLineIndex: number, columnIndex: number) => ({
  type: ActionType.ADD_FOOD_TRAY_COLUMN,
  payload: {
    foodTrays,
    foodLineIndex,
    columnIndex,
  },
});

export const removeFoodTrayColumn = (foodLineIndex: number, columnIndex: number) => ({
  type: ActionType.REMOVE_FOOD_TRAY_COLUMN,
  payload: {
    foodLineIndex,
    columnIndex,
  },
});

export const setFoodTrayProp = (
  propName: keyof FoodTray,
  propValue: ValueOf<FoodTray>,
  foodLineIndex: number, // We use the index and not the id or the objects since the object could be new and not have an id yet
  columnIndex: number, // We use the index and not the id or the objects since the object could be new and not have an id yet
  rowIndex: number, // We use the index and not the id or the objects since the object could be new and not have an id yet
) => ({
  type: ActionType.SET_FOOD_TRAY_PROP,
  payload: {
    propName,
    propValue,
    foodLineIndex,
    columnIndex,
    rowIndex,
  },
});
